import { Buffer } from 'buffer';
(window as any).Buffer = Buffer;
